module.exports = __webpack_public_path__ + "img/icon-copy.e736a531.svg";